<template>
  <Accordion title="Dados da Movimentação">
    <div class="grid grid-cols-4 gap-5">
      <InputNumber :modelValue="localValue.id" disabled label="Código" v-if="localValue.id" />
      <Select disabled :items="allTypes" v-model="localValue.type" label="Tipo" required :error="localErrors.type" />
      <InputNumber :modelValue="localValue.idMaterialRequest" disabled label="Código da Requisição" v-if="localValue.type === 'request'" />
      <InputZoom
        clearable
        required
        disabled
        label="Local Origem"
        v-model="localValue.idOriginWarehouse"
        :error="localErrors.idOriginWarehouse || localErrors.sameWarehouse"
        v-model:complete-object="completeObject"
        database="warehouse"
        item-text="name"
        item-value="id"
        :filter="originWarehouseFilters"
        placeholder="Selecione o depósito" />

      <InputZoom
        clearable
        required
        disabled
        v-model="localValue.idDestinationWarehouse"
        label="Local Destino"
        :error="localErrors.idDestinationWarehouse || localErrors.sameWarehouse"
        database="warehouse"
        item-text="name"
        item-value="id"
        v-model:complete-object="completeObject2"
        :filter="computedItemsFilters"
        placeholder="Selecione o depósito" />

      <InputDateTime disabled v-model="localValue.date" label="Data" :error="localErrors.date" required />

      <InputZoom
        v-model="localValue.idUser"
        disabled
        clearable
        label="Responsável"
        :error="localErrors.idUser"
        database="user"
        item-text="name"
        item-value="id"
        required
        placeholder="Selecione o responsável" />

      <TextArea class="col-span-4" v-model="localValue.description" label="Descrição" placeholder="Insira uma descrição" :error="localErrors.description" />
    </div>
  </Accordion>
</template>

<script setup>
import { computed, reactive, ref, watch, onMounted } from 'vue'
import { useFormat } from '@/composables/useFormat'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import moment from 'moment'

const store = useStore()
const user = computed(() => store.state.user)

const { formatDatetimeToTimezone } = useFormat()

const props = defineProps({
  modelValue: Object,
  error: Object,
})

const emits = defineEmits(['update:modelValue'])

const localValue = reactive(props.modelValue)
const localErrors = ref(props.error)
const completeObject = ref(null)
const completeObject2 = ref(null)

// Módulo para Corrigir tipos
const allTypes = [
  { label: 'Fornecimento', value: 'outgoing' },
  { label: 'Transferência', value: 'transfer' },
  { label: 'Devolução', value: 'devolution' },
  { label: 'Devolução ao Fornecedor', value: 'supplierDevolution' },
  { label: 'Baixa', value: 'downward' },
  { label: 'Fornecimento por Requisição', value: 'request' },
]

const originWarehouseFilters = [{ column: 'type', operator: '=', value: 'physic' }]

// Computeds
const computedItemsFilters = computed(() => {
  if (completeObject.value) {
    return [{ column: 'type', operator: '!=', value: 'physic' }]
  }
  return []
})
//  Watchers
watch(
  () => props.modelValue,
  (newValue) => {
    localValue.value = newValue
  },
)

watch(
  () => props.error,
  (newValue) => {
    localErrors.value = newValue
  },
)

watch(localValue, (newValue) => {
  emits('update:modelValue', newValue)
})

// Hooks
onMounted(() => {
  // localValue.date = moment()
  localValue.idUser = user.value.id
})
</script>
